<template>
  <div>
    <div class="mian">
      <div class="numCon">
        <div class="numText">
          <div class="btext">
            {{ list[list.length - 1].op.op.balance
            }}<span style="font-size: 14px">积分</span>
          </div>
          <div>我的奖励</div>
        </div>
      </div>
      <div>
        <div v-for="(item, index) in list" :key="index">
          <div class="goodsInfo goodsInfo2">
            <div class="goodsInfo-text">
              <div>交易类型</div>
              <div class="goodsInfo-text-num texts" style="margin-left: 34px">
                {{ item.op.op.trade_type == 0 ? "入账" : "出账" }}
              </div>
            </div>
            <div class="goodsInfo-text">
              <div>交易积分</div>
              <div
                class="goodsInfo-text-num texts"
                style="margin-left: 53px"
                :style="{
                  color: item.op.op.trade_type == 1 ? 'red' : '#127855',
                }"
              >
                <span>{{ item.op.op.trade_type == 1 ? "-" : "+" }}</span
                >{{ item.op.op.trade_amount }}积分
              </div>
            </div>
            <div class="goodsInfo-text">
              <div>账户ID</div>
              <div class="goodsInfo-text-num texts" style="margin-left: 53px">
                {{ item.op.op.point_account_id }}
              </div>
            </div>
            <div class="goodsInfo-text">
              <div style="width: 65px">交易时间</div>
              <div class="goodsInfo-text-num texts" style="margin-left: 28px">
                {{ item.op.op.trade_date }}
              </div>
            </div>
            <div class="goodsInfo-text">
              <div class="goods-title" style="width: 170px">区块链标识</div>
              <div
                class="goodsInfo-text-num texts"
                style="word-wrap: break-word"
              >
                {{ item.txid }}
              </div>
            </div>
          </div>
          <!-- <div class="goods-characteristic">
            <div class="goods-characteristic-inner">
              <span @click="toBlockChain(item)">
                区块链标识：{{ item.txid }}</span
              >
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import { ImagePreview } from "vant";
import Sertificate from "../components/Sertificate.vue";

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay);

export default {
  components: { Sertificate },

  props: {
    digitalAssetInfo: Object,
  },
  watch: {
    digitalAssetInfo(curVal, oldVal) {
      console.log(oldVal, "oldVal");
      if (curVal) {
        this.digitalAssetInfo = curVal;
        console.log(this.digitalAssetInfo);
        // this.jyInfo.data_list.forEach((item) => {
        //   item.msgItems.forEach((i) => {
        //     i.op.op = JSON.parse(i.op.op);
        //   });
        // });
        this.list = this.digitalAssetInfo.data_list[0].msgItems;
        this.list.forEach((item) => {
          item.op.op = JSON.parse(item.op.op);
        });
        this.list = this.list.filter((item) => {
          return item.op.op.trade_type !== 2;
        });
        console.log(this.list, "zzzzzzzzzzzzzzzzzz");
        // console.log(this.list, "list");
        // // this.list.forEach((item) => {
        //   if (item.op.op.receiver_name) {
        //     this.receiver_name = item.op.op.receiver_name;
        //     console.log(
        //       "------------------------------------------------------------",
        //       this.receiver_name
        //     );
        //   }
        // });
        // this.list.forEach((item) => {
        //   this.listPic = item.msgItems[0];
        // });
        // this.listInfo = this.listPic.op.op.picurl.split(",").slice(0, 3);
      }
    },
  },
  data() {
    return {
      listData: [],
      list: [],
      receiver_name: "",
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {
    // this.listData = JSON.parse(
    //   window.localStorage.getItem("defalutObj")
    // )
    // console.log('liu', this.listData);
    // this.list = this.listData.filter(item => item.trace_name === '交易信息')
    // this.list.forEach(item => {
    //   this.list = item.msgItems
    // })
    // this.list.forEach(item => {
    //   if(item.op.op.receiver_name) {
    //     this.receiver_name = item.op.op.receiver_name
    //     console.log('------------------------------------------------------------',this.receiver_name);
    //   }
    // })
    // console.log('liutong', this.list[0].op.op)
  },
  methods: {
    switch_image(img) {
      ImagePreview([img]);
    },
    toBlockChain(item) {
      this.show = true;
      this.ts = item.ts;
      this.txid = item.txid;
      // console.log(this.list);
      // this.$router.push(`/Look?ts=${this.list.ts}&txid=${this.list.txid}`);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  .numCon {
    width: 676px;
    height: 162px;
    background: #f8f8f8;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .numText {
      margin-left: 38px;
    }
    .btext {
      color: #222;
      font-size: 60px;
      font-weight: bold;
    }
  }
  position: relative;
  width: 608px;
  margin-bottom: 20px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .product {
    width: 638px;
    height: 828px;
    background-color: skyblue;
    padding: 172px 0 30px 56px;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: -13vw;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
      }
    }
    .picture {
      width: 496px;
      height: 818px;
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 34px 60px 0 50px;
    }
  }
  .goodsInfo2 {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;

    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: 404px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 36px;
    padding: 30px;
    .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .texts {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;

      color: #000000;
      opacity: 1;
    }
    .goodsInfo-text {
      display: flex;
    }
  }
  .goods-characteristic {
    margin: 0 auto;
    width: 536px;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .b-material {
    .swipe-wrap {
      width: 546px;
      height: 250px;

      margin: 0 auto;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .material {
      display: flex;
      justify-content: space-between;
      width: 548px;
      height: 49px;

      align-items: center;
      margin: 0 auto;
      border-bottom: 2px solid #e8e8e8;
      .dian {
        .m-title {
          width: 112px;
          height: 40px;
          font-weight: 400;
          line-height: 0px;
          margin-left: 15px;
          margin-top: 5px;
        }
        width: 12px;
        height: 12px;
        background: #000000;
        border-radius: 50%;
        opacity: 1;
        margin-right: -330px;
        font-size: 28px;
      }
      .date {
        width: 250px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: #919ab1;
        opacity: 1;
      }
    }
  }
}
</style>